import React, { useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { NIL as NIL_UUID } from 'uuid';

const SelectTree = (props) => {
    const refTreeMenu = useRef();
    const refTreeInput = useRef();
    const {
        data,
        actions,
        onChange,
        positionExpand,
        multiSelect,
        Placeholder,
        searchKeyword,
        showSearchBox,
        singleValueSelected,
        multiValueSelected,
        isInvalid,
        typeChoose,
    } = props;

    const [listData, setListData] = useState([]);
    const [listDataSearch, setDataSearch] = useState([]);
    const [valueSelect, setValueSelect] = useState('');
    const [listSelected, setListSelected] = useState([]);

    const unCheck = 'unCheck';
    const checked = 'checked';
    const checking = 'checking';

    const addParentToTree = (parentId, listSearch) => {
        if (parentId !== undefined) {
            const node = listDataSearch.find((x) => x.id === parentId);
            if (node) {
                node.expand = true;
                if (!listSearch.some((x) => x.id === parentId)) {
                    listSearch.push(node);
                }
                listSearch = addParentToTree(node.parentId, listSearch);
            }
        }
        return listSearch;
    };

    const handleSelectParent = (parentId, listDataNew) => {
        const children = listDataNew.filter((x) => x.parentId === parentId);
        const childrenChecked = children.filter(
            (x) => x.checked === checked || x.checked === checking
        );
        const parent = listDataNew.find((x) => x.id === parentId);
        if (parent && !parent.isGroup) {
            parent.checked =
                children && childrenChecked.length > 0
                    ? children.length === childrenChecked.length
                        ? checked
                        : checking
                    : unCheck;
            if (parent.parentId !== '') {
                listDataNew = handleSelectParent(parent.parentId, listDataNew);
            }
        }
        return listDataNew;
    };

    const handleSearchOnTree = (value, listSearch = listDataSearch) => {
        if (listSearch.length > 0) {
            let listDataNew;
            if (value.length > 0) {
                listDataNew = listSearch.filter((item) =>
                    item.name.toLowerCase().includes(value.toLowerCase())
                );
                listDataNew.forEach((element) => {
                    listDataNew = addParentToTree(element.parentId, listDataNew);
                });
            } else {
                listDataNew = listSearch;
            }
            setListData(listDataNew);
        }
    };

    React.useEffect(() => {
        let dataMap = [];
        if (listData.length === 0) {
            dataMap = data.map((item) => ({ ...item, expand: false, checked: unCheck }));
        } else {
            data.forEach((element) => {
                const itemTree = listData.find((x) => x.id === element.id);
                dataMap.push({
                    ...element,
                    expand: itemTree ? itemTree.expand : false,
                    checked: itemTree ? itemTree.checked : unCheck,
                });
            });
        }

        const listSelectedNew = [];
        if (multiValueSelected && multiValueSelected.length > 0) {
            multiValueSelected.forEach((value) => {
                const itemSelected = dataMap.find((x) => x.id === value);
                if (itemSelected) {
                    itemSelected.checked = checked;
                    if (itemSelected.parentId !== '') {
                        dataMap = handleSelectParent(itemSelected.parentId, dataMap);
                    }
                    listSelectedNew.push(itemSelected);
                }
            });
        }

        setListData(dataMap);
        setDataSearch(dataMap);
        handleSearchOnTree(searchKeyword, dataMap);
        setValueSelect(
            singleValueSelected && singleValueSelected !== '' ? singleValueSelected : valueSelect
        );
        setListSelected(listSelectedNew.length > 0 ? listSelectedNew : listSelected);
    }, [data, searchKeyword, singleValueSelected, multiValueSelected]);

    const genTree = (items, id = NIL_UUID, levelTree = 1, link = 'parentId') =>
        items
            .filter((item) => item[link] === id)
            .map((item) => ({ ...item, level: levelTree, children: genTree(items, item.id, levelTree + 1) }));

    const listTree = genTree(listData);

    const handleExpandTree = (item) => {
        const listDataNew = [...listData];
        listDataNew.map((x) => {
            if (x.id === item.id) {
                x.expand = !x.expand;
            }
            return x;
        });
        setListData(listDataNew);
    };

    function handleOutsideClick(e) {
        if (refTreeMenu.current) {
            if (refTreeInput.current.contains(e.target)) {
                if (e.target.tagName.includes('path') || e.target.tagName.includes('svg') || e.target.tagName.includes('INPUT')) {
                    return;
                }
            }
            if (refTreeMenu.current.contains(e.target)) {
                return;
            }
            document.removeEventListener('click', handleOutsideClick, false);
            if (refTreeMenu.current.classList.contains('show')) {
                refTreeMenu.current.classList.remove('show');
            }
        }
    }

    function handleOpenBoxTree() {
        if (!refTreeMenu.current.classList.value.includes('show')) {
            document.addEventListener('click', handleOutsideClick, false);
            refTreeMenu.current.classList.toggle('show');
        }
    }

    const handleSelectChildren = (isChecked, parentId, listDataNew) => {
        listDataNew.forEach((item) => {
            if (item.parentId === parentId) {
                item.checked = isChecked;
                item.expand = true;
                listDataNew = handleSelectChildren(isChecked, item.id, listDataNew);
            }
        });
        return listDataNew;
    };

    const handleSelectMulti = (e, item) => {
        if (!multiSelect || e.target.tagName.includes('path') || e.target.tagName.includes('svg')) return;
        if (item.isGroup) return;
        try {
            let listDataGlobal = [...listDataSearch];
            const node = listDataGlobal.find((x) => x.id === item.id);
            if (!node) return;
            const statusCheck = node.checked === checking || node.checked === unCheck ? checked : unCheck;
            listDataGlobal = listDataGlobal.map((x) => {
                if (x.id === item.id) return { ...x, checked: x.checked === checking || x.checked === unCheck ? checked : unCheck, expand: true };
                return x;
            });
            listDataGlobal = handleSelectChildren(statusCheck, item.id, listDataGlobal);
            if (item.parentId !== '') listDataGlobal = handleSelectParent(item.parentId, listDataGlobal);
            const dataChange = listDataGlobal.filter((x) => x.checked === checked || x.checked === checking);
            setDataSearch(listDataGlobal);
            handleSearchOnTree(searchKeyword, listDataGlobal);
            setListSelected(dataChange);
            onChange(dataChange);
        } catch (err) {
            console.error('handleSelectMulti error', err);
        }
    };

    const handleSelect = (e, item) => {
        if (typeChoose && item.dataType !== typeChoose) return;
        if (e.target.tagName.includes('path') || e.target.tagName.includes('svg') || e.target.tagName.includes('SPAN') || e.target.tagName.includes('I')) return;
        setValueSelect(item);
        onChange(item);
        if (refTreeMenu.current.classList.value.includes('show')) {
            document.removeEventListener('click', handleOutsideClick, false);
            refTreeMenu.current.classList.toggle('show');
        }
    };

    const handleSearchChange = (e) => handleSearchOnTree(e.target.value);

    const renderItemTree = (items, expand = true) => {
        return items
            ? items.map((item) => (
                  <div key={item.id}>
                      <div className={`tree_item_children ${expand && 'tree_item_active'}`}>
                        <div
                            className={`tree_item ${multiSelect ? 'cursor-pointer' : ''} ${!multiSelect && 'cursor-pointer'}`}
                            style={{ paddingLeft: 10 + (item.level - 1) * 20 }}
                            role="presentation"
                            onClick={(e) => handleRowClick(e, item)}
                        >
                              {item.children.length > 0 && positionExpand === 'left' ? (
                                <span style={{ padding: 5 }} className="expand" role="presentation" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleExpandTree(item);
                                }}>
                                      <i className="fas fa-caret-up" style={{ display: item.expand ? 'block' : 'none' }} />
                                      <i className="fas fa-caret-down" style={{ display: item.expand ? 'none' : 'block' }} />
                                  </span>
                              ) : null}

                            <label
                                className={`container_check ${!multiSelect && 'container_check_hide'} ${typeChoose && typeChoose !== item.dataType && 'text__line-through'}`}
                                onClick={(e) => e.stopPropagation()}
                            >

                                <input
                                    type="checkbox"
                                    checked={item.checked === checked || item.checked === checking}
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        toggleMultiItem(item);
                                    }}
                                />

                                  {item.name}
                                  <span className={`checkmark ${item.checked} ${item.checked === checking && 'checkmark_parent'}`} />
                              </label>

                              {item.children.length > 0 && positionExpand === 'right' ? (
                                <span style={{ padding: 5 }} className="expand" role="presentation" onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleExpandTree(item);
                                }}
>
                                      <i className="fas fa-caret-up" style={{ display: item.expand ? 'block' : 'none' }} />
                                      <i className="fas fa-caret-down" style={{ display: item.expand ? 'none' : 'block' }} />
                                  </span>
                              ) : null}

                              <div className="tree_item_action">
                                  {actions.map((action) => (
                                      <NavLink
                                          key={action.title}
                                          style={{ padding: 0 }}
                                          onClick={(e) => {
                                              e.preventDefault();
                                              e.stopPropagation();
                                              action.action(item);
                                          }}
                                      >
                                          <action.Icon title={action.title} color={action.color} className="table-action-control" />
                                      </NavLink>
                                  ))}
                              </div>
                          </div>
                          {renderItemTree(item.children, item.expand)}
                      </div>
                  </div>
              ))
            : null;
    };

    const handleRemoveSelected = (e, item) => {
        // Không cho click lan ra ngoài (tránh mở dropdown khi bấm X)
        e.preventDefault();
        e.stopPropagation();

        try {
            let listDataGlobal = [...listDataSearch];

            const node = listDataGlobal.find((x) => x.id === item.id);
            if (!node) return;

            // Set node về unCheck
            listDataGlobal = listDataGlobal.map((x) => {
                if (x.id === item.id) return { ...x, checked: unCheck, expand: true };
                return x;
            });

            // Uncheck toàn bộ con (nếu node có children)
            listDataGlobal = handleSelectChildren(unCheck, item.id, listDataGlobal);

            // Cập nhật trạng thái parent (checked/checking/unCheck)
            if (item.parentId !== '') {
                listDataGlobal = handleSelectParent(item.parentId, listDataGlobal);
            }

            // Lấy lại danh sách đã chọn
            const dataChange = listDataGlobal.filter(
                (x) => x.checked === checked || x.checked === checking
            );

            setDataSearch(listDataGlobal);
            handleSearchOnTree(searchKeyword, listDataGlobal);
            setListSelected(dataChange);
            onChange(dataChange);
        } catch (err) {
            console.error('handleRemoveSelected error', err);
        }
    };

    const toggleMultiItem = (item) => {
        if (!multiSelect) return;
        if (item.isGroup) return;
        if (typeChoose && item.dataType !== typeChoose) return;

        try {
            let listDataGlobal = [...listDataSearch];
            const node = listDataGlobal.find((x) => x.id === item.id);
            if (!node) return;

            const statusCheck =
                node.checked === checking || node.checked === unCheck ? checked : unCheck;

            // toggle node
            listDataGlobal = listDataGlobal.map((x) => {
                if (x.id === item.id) return { ...x, checked: statusCheck, expand: true };
                return x;
            });

            // toggle children + update parent
            listDataGlobal = handleSelectChildren(statusCheck, item.id, listDataGlobal);
            if (item.parentId !== '') listDataGlobal = handleSelectParent(item.parentId, listDataGlobal);

            const dataChange = listDataGlobal.filter(
                (x) => x.checked === checked || x.checked === checking
            );

            setDataSearch(listDataGlobal);
            handleSearchOnTree(searchKeyword, listDataGlobal);
            setListSelected(dataChange);
            onChange(dataChange);
        } catch (err) {
            console.error('toggleMultiItem error', err);
        }
    };

    const handleRowClick = (e, item) => {
        // Single select: giữ nguyên behavior cũ
        if (!multiSelect) return handleSelect(e, item);

        // Multi select: click dòng để toggle (trừ các vùng đặc biệt)
        const t = e.target;

        // Nếu bấm vào checkbox/label, expand, action thì bỏ qua (để tránh toggle 2 lần)
        if (
            t.closest('.container_check') ||
            t.closest('.expand') ||
            t.closest('.tree_item_action')
        ) {
            return;
        }

        toggleMultiItem(item);
    };



    return (
        <>
            <div style={{ position: 'relative' }} ref={refTreeInput}>
                <span className={` select2 select2-container select2-container--default select2-container--below ${listSelected && listSelected.length > 0 && 'select2-container--focus'}`} role="presentation" dir="ltr" onClick={() => handleOpenBoxTree()} style={{ width: '100%' }}>
                    <span className="selection">
                        <span className={`select2-selection select2-selection--multiple ${isInvalid ? 'is-invalid' : ''}`} aria-haspopup="true" aria-expanded="false" tabIndex={-1} style={{ display: 'flex', width: '100%', boxSizing: 'border-box', whiteSpace: 'normal', flexWrap: 'wrap', alignItems: 'flex-start', border: '1px solid #ced4da', borderRadius: 4, padding: 0, minHeight: 38, background: 'transparent' }}>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'flex-start', padding: '6px', width: '100%', boxSizing: 'border-box', overflow: 'visible' }}>
                                {listSelected && listSelected.length > 0 ? (
                                    listSelected.map((item) => (
                                        <div
                                            key={item.id}
                                            className="select2-selection__choice"
                                            title={item.name}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                padding: '6px 10px',
                                                background: '#0d6efd',
                                                color: '#fff',
                                                borderRadius: 12,
                                                margin: '2px',
                                                fontSize: 13,
                                                wordBreak: 'break-word',
                                                overflowWrap: 'anywhere',
                                                flex: '0 0 auto',
                                                maxWidth: 320,
                                                minWidth: 0,
                                                gap: 8,
                                            }}
                                        >
                                            <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {item.name}
                                            </span>

                                            {/* Nút X để bỏ chọn */}
                                            <span
                                                role="button"
                                                aria-label={`remove-${item.id}`}
                                                title="Bỏ chọn"
                                                onClick={(e) => handleRemoveSelected(e, item)}
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    width: 18,
                                                    height: 18,
                                                    borderRadius: '50%',
                                                    background: 'rgba(255,255,255,0.25)',
                                                    cursor: 'pointer',
                                                    fontWeight: 700,
                                                    lineHeight: 1,
                                                    userSelect: 'none',
                                                    flex: '0 0 auto',
                                                }}
                                            >
                                                ×
                                            </span>
                                        </div>
                                    ))
                                ) : null}


                                <div style={{ flex: 1, minWidth: 140, overflow: 'hidden' }} className="select2-search select2-search--inline">
                                    <Form.Control value={multiSelect ? '' : (valueSelect && valueSelect.name) || ''} placeholder={Placeholder} className="select2-search__field" type="text" onChange={() => {}} tabIndex={0} readOnly style={{ border: 'none', boxShadow: 'none', background: 'transparent', width: '100%' }} />
                                </div>
                            </div>
                        </span>
                    </span>
                </span>

                <div className="dropdown-menu" style={{ padding: 0, maxHeight: '280px', overflowY: 'auto' }} ref={refTreeMenu}>
                    {showSearchBox && (
                        <div style={{ padding: 10 }}>
                            <Form.Control placeholder="Tìm kiếm ..." type="text" onChange={(e) => handleSearchChange(e)} />
                        </div>
                    )}

                    {renderItemTree(listTree)}
                </div>
            </div>
        </>
    );
};

SelectTree.prototype = {
    actions: PropTypes.array,
    positionExpand: PropTypes.string,
    multiSelect: PropTypes.bool,
    showSearchBox: PropTypes.bool,
    Placeholder: PropTypes.string,
    searchKeyword: PropTypes.string,
    data: PropTypes.array,
    onChange: PropTypes.func,
    singleValueSelected: PropTypes.string,
    multiValueSelected: PropTypes.array,
    EnableValidate: PropTypes.bool,
    ErrorMessage: PropTypes.string,
    ForceValidate: PropTypes.bool,
    isInvalid: PropTypes.bool,
};

SelectTree.defaultProps = {
    actions: [],
    positionExpand: 'left',
    multiSelect: false,
    showSearchBox: false,
    Placeholder: '',
    searchKeyword: '',
    data: [],
    onChange: () => {},
    singleValueSelected: '',
    multiValueSelected: [],
    EnableValidate: false,
    ErrorMessage: '',
    ForceValidate: false,
    isInvalid: false,
};

export default SelectTree;
